<template>
  <div>
    <vuestic-modal
      :show.sync="modalInfo.show"
      v-bind:small="true"
      v-bind:force="true"
      ref="modalInfo"
      :cancelClass="'none'"
      :okText="'modal.close' | translate"
    >
      <div slot="title">{{ modalInfo.title }}</div>
      <div>{{ modalInfo.body }}</div>
    </vuestic-modal>

    <existing-invoice-action ref="existingInvoiceComponent"
                             :unpaidInvoice="this.unpaidInvoice"></existing-invoice-action>

    <div class="form-wizard-page">
      <div class="row">
        <div class="col-md-12">
          <vuestic-widget class="no-h-padding" :headerText="$t('upgrade.wizard.rich')">
            <vuestic-wizard
              :steps="hrSteps"
              :lastStepLabel="$t('upgrade.wizard.confirm')"
              wizard-type="rich"
              ref="upgradeForm"
            >
              <div slot="page1" class="form-wizard-tab-content">
                <div class="form-wizard-tab-content-text">
                  <p>
                    <b>{{ $t('upgrade.step1') }}</b>
                  </p>
                </div>
                <vuestic-simple-select
                  :label="$t('upgrade.selectServer')"
                  v-model="vmSelected"
                  name="server"
                  :required="true"
                  ref="hrVmSelect"
                  option-key="name"
                  v-bind:options="vms"
                ></vuestic-simple-select>
              </div>

              <div slot="page2" class="form-wizard-tab-content">
                <div class="form-wizard-tab-content-text">
                  <h3>{{ $t('upgrade.step2-p1') }}</h3>

                  <div class="row">
                    <div class="col-xs-12 col-md-12">
                      <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-striped first-td-padding">
                          <tbody>
                          <tr>
                            <td>
                              <b>{{ $t('upgrade.plan')}}</b>
                            </td>
                            <td>
                              <b>
                                  <span
                                    style="font-size: 0.8em; text-transform: none;"
                                    class="badge badge-pill badge-warning"
                                  >{{ actualPlan.product_name }} - {{ $t('upgrade.currency') }} {{ hosting ? Number(hosting.amount).toFixed(2) : '' }}</span>
                              </b>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <b>{{$t('upgrade.billingcycle2')}}</b>
                            </td>
                            <td>
                                <span
                                  style="font-size: 0.8em; text-transform: none;"
                                  class="badge badge-pill badge-warning"
                                >{{ $t('upgrade.billingcycle.' + hosting.billingcycle) }}</span>
                            </td>
                          </tr>
                          <tr v-for="(item, key) in actualPlan.settings" :key="key">
                            <td v-if="item.product_settings">{{ $t('order.' + item.product_settings.name) }}</td>
                            <td v-if="item.product_settings">{{ formatSetting(item.product_settings.name, item.value, item.product_settings.unity,
                              item.product_settings.type) }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <b>{{ $t('upgrade.currency') }} {{ hosting ? Number(hosting.amount).toFixed(2) : '' }} /
                                {{ $t('upgrade.billingcycle.' + hosting.billingcycle) }}</b>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <hr/>
                  <h3>{{ $t('upgrade.step2') }}</h3>
                  <Order :key="reloadOrder" :item="actualPlan" @new-item="setNewPlan" :preSelectProductProp="actualPlan.product" :showResume="false"/>
                </div>
              </div>

              <div slot="page3" class="form-wizard-tab-content">
                <div class="form-wizard-tab-content-text">
                  <h3>{{ $t('upgrade.oldPlan') }}</h3>

                  <div class="row">
                    <div class="col-xs-12 col-md-12">
                      <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-striped first-td-padding">
                          <tbody>
                          <tr>
                            <td>
                              <b>{{ $t('upgrade.plan')}}</b>
                            </td>
                            <td>
                              <b>
                                  <span
                                    style="font-size: 0.8em; text-transform: none;"
                                    class="badge badge-pill badge-warning"
                                  >{{ hosting.display }} - {{ $t('upgrade.currency') }} {{ hosting ? Number(hosting.amount).toFixed(2) : '' }}</span>
                              </b>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <b>{{$t('upgrade.billingcycle2')}}</b>
                            </td>
                            <td>
                                <span
                                  style="font-size: 0.8em; text-transform: none;"
                                  class="badge badge-pill badge-warning"
                                >{{ $t('upgrade.billingcycle.' + hosting.billingcycle) }}</span>
                            </td>
                          </tr>
                          <tr v-for="(item, key) in actualPlan.settings" :key="key">
                            <td v-if="item.product_settings">{{ $t('order.' + item.product_settings.name) }}</td>
                            <td v-if="item.product_settings">{{ formatSetting(item.product_settings.name, item.value, item.product_settings.unity,
                              item.product_settings.type) }}
                            </td>
                          </tr>
                          <tr>
                            <td></td>
                            <td>
                              <b>{{ $t('upgrade.currency') }} {{ hosting ? Number(hosting.amount).toFixed(2) : '' }} /
                                {{ $t('upgrade.billingcycle.' + hosting.billingcycle) }}</b>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>

                  <hr/>
                  <h3 class="mt-5">{{ $t('upgrade.newPlan') }}</h3>

                  <div class="row">
                    <span class="arrow-down"></span>
                    <div class="col-xs-12 col-md-12">
                      <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-striped first-td-padding">
                          <tbody>

                          <tr v-if="newPlan.product">
                            <td>
                              <b>{{ $t('upgrade.plan')}}</b>
                            </td>
                            <td>
                              <b>
                                  <span
                                    style="font-size: 0.8em; text-transform: none;"
                                    class="badge badge-pill badge-warning"
                                  >{{ newPlan.product.name }} - {{ $t('upgrade.currency') }} {{ Number(quote.recurring_price).toFixed(2) }}</span>
                              </b>
                            </td>
                          </tr>

                          <tr>
                            <td>
                              <b>{{$t('upgrade.billingcycle2')}}</b>
                            </td>
                            <td>
                                <span
                                  style="font-size: 0.8em; text-transform: none;"
                                  class="badge badge-pill badge-warning"
                                >{{ $t('upgrade.billingcycle.' + hosting.billingcycle) }}</span>
                            </td>
                          </tr>

                          <tr v-for="(setting, index) in newPlan.settings" :key="index">
                            <td>{{ $t('order.' + setting.name) }}</td>
                            <td>{{ formatSetting(setting.name, setting.value, setting.unity, setting.type) }}</td>
                          </tr>

                          <tr>
                            <td></td>
                            <td>
                              <b>{{ $t('upgrade.currency') }} {{ Number(quote.recurring_price).toFixed(2) }} / {{
                                $t('upgrade.billingcycle.' + hosting.billingcycle) }}</b>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>


                  <hr/>
                  <h3 class="mt-5">{{ $t('upgrade.payNow') }}</h3>
                  <div class="row">
                    <div class="col-xs-12 col-md-12">
                      <div class="table-responsive" style="overflow-x: auto">
                        <table class="table table-striped first-td-padding">
                          <tbody>
                          <tr>
                            <td>
                              <b>{{ $t('upgrade.period')}}</b>
                            </td>
                            <td>
                              {{ $t('upgrade.from')}}
                              <b>{{ this.dateFormat(this.quote.period_start, 'date') }}</b>
                              {{ $t('upgrade.until')}}
                              <b>{{ this.dateFormat(this.quote.period_end, 'date') }}</b>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <b>{{$t('upgrade.proportional')}}</b>
                            </td>
                            <td>{{$t('upgrade.currency')}} {{ Number(this.quote.pay_now).toFixed(2) }}</td>
                          </tr>
                          <tr>
                            <td>
                              <b>{{$t('upgrade.upgradeFee')}}</b>
                            </td>
                            <td>{{$t('upgrade.currency')}} {{ Number(this.quote.fee).toFixed(2) }}</td>
                          </tr>
                          <tr>
                            <td>
                              <b>{{$t('upgrade.total')}}</b>
                            </td>
                            <td>{{$t('upgrade.currency')}} {{ Number(this.quote.pay_now + this.quote.fee).toFixed(2)
                              }}
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <p>{{$t('upgrade.upgradeInfo')}}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div slot="wizardCompleted" class="form-wizard-tab-content">
                <h4>{{'upgrade.step4Title' | translate}}</h4>
                <p>
                  <a :href="this.invoiceUrl">{{ $t('upgrade.step4') }}</a>
                </p>
                <p>{{ $t('upgrade.step4Bottom') }}</p>
              </div>
            </vuestic-wizard>
          </vuestic-widget>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <vuestic-widget :headerText="$t('upgrade.history')">
          <vuestic-data-table
            ref="upgradeTable"
            :apiMode="apiMode"
            :tableData="tableData"
            :tableFields="tableFields"
            :itemsPerPage="itemsPerPage"
            :itemsPerPageLabel="$t('dashboard.perPage')"
            :onEachSide="onEachSide"
            :sortFunctions="sortFunctions"
            :dataModeFilterableFields="dataModeFilterableFields"
          />
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import BadgeColumn from 'components/tables/BadgeColumn.vue'
  import FieldsDef from './fields-definition'
  import CustomActions from './ManageAction'
  import ExistingInvoiceAction from './ExistingInvoiceAction'
  import Order from '../order/Order.vue';

  import store from '../../store'
  import ajax from 'services/ajax'
  import time from 'services/time'
  import configs from 'services/configs'
  import {getAxios} from 'services/ajax'
import iframeUtil from '../../services/iframeUtil'

  Vue.component('upgrade-custom-actions', CustomActions)
  Vue.component('badge-column', BadgeColumn)
  Vue.component('existing-invoice-action', ExistingInvoiceAction)


  export default {
    name: 'upgrade',
    components: {
      Order
    },
    created() {
      // Translate table column
      this.tableFields[1].title = this.$t('upgrade.server')
      this.tableFields[3].title = this.$t('upgrade.created_at')

      store.commit('setLoading', true)
      let requestsFinished = 0

      ajax.run(
        this,
        'customer/upgrades',
        data => {
          this.tableData = {
            data: data
          }
          requestsFinished++
          this.stopLoadingAfter(requestsFinished)
        },
        error => {
          store.commit('setLoading', false)
          console.log(error)
        }
      )

      ajax.run(
        this,
        'customer/vms',
        data => {
          let instance = this
          data.forEach(function (vm) {
            vm.vm_nics.forEach(function (vmNic) {
              instance.vms.push({
                ip: vmNic.ip.ip_address,
                name: 'vps' + vm.hosting_id + ' - ' + vmNic.ip.ip_address,
                hosting_id: vm.hosting_id
              })
            })
          })
          requestsFinished++
          this.stopLoadingAfter(requestsFinished)
        },
        error => {
          store.commit('setLoading', false)
          console.log(error)
        }
      )

      ajax.run(
        this,
        'customer/whmcs/get/payment-methods',
        data => {
          this.paymentGateways = data
        },
        error => {
          console.log(error)
        }
      )
    },
    mounted() {
      this.$refs.upgradeTable.formatStatus = function (value) {
        switch (value) {
          case 'pending':
            return this.$t('upgrade.pending')
          case 'complete':
            return this.$t('upgrade.complete')
          case 'cancelled':
            return this.$t('upgrade.cancelled')
          default:
            return ''
        }
      }
      this.$refs.upgradeTable.formatDate = function (value) {
        return time.convert(value, 'date')
      }
    },
    computed: {
      invoiceUrl() {
        if (this.quote.invoice && typeof this.quote.invoice.invoiceid !== 'undefined') {
          return configs.CLIENT_AREA() + 'viewinvoice.php?id=' + this.quote.invoice.invoiceid
        } else {
          return ''
        }
      },
      hrSteps() {
        return [
          {
            label: this.$t('upgrade.wizard.stepOne'),
            slot: 'page1',
            onNext: () => {
              this.setup()

              this.$refs.hrVmSelect.validate()
              this.getPlans()
            },
            isValid: () => {
              return this.$refs.hrVmSelect.isValid()
            }
          },
          {
            label: this.$t('upgrade.wizard.stepTwo'),
            slot: 'page2',
            onNext: async () => {
            },
            isValid: () => {
              if (this.isPlanSelected() && this.isPaymentSelected()) {
                document.body.scrollTop = 0 // For Safari
                document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera
                this.upgradeQuote(false)
                return true
              } else {
                return false
              }
            }
          },
          {
            label: this.$t('upgrade.wizard.stepThree'),
            slot: 'page3',
            onNext: () => {
              if (this.isPlanSelected() && this.isPaymentSelected()) {
                document.body.scrollTop = 0 // For Safari
                document.documentElement.scrollTop = 0 // For Chrome, Firefox, IE and Opera

                this.upgradeQuote(true, function (instance) {
                  console.log(instance.quote)

                  iframeUtil.sendEventToParent('redirect', {
                    invoiceId: instance.quote.invoice.invoiceid,
                  })

                  const formData = new FormData()
                  formData.append('destination', `viewinvoice.php?id=${instance.quote.invoice.invoiceid}`)

                  getAxios().post('sso', formData)
                    .then(response => {
                      window.location.href = response.data.WhmcsAutoLoginClient.data.redirect_url
                    })
                    .catch(err => {
                      this.showToast(this.$t('global_error.internal'), {
                        icon: 'fa-exclamation',
                        position: 'top-center',
                        duration: 3000,
                        fullWidth: false
                      })

                      return false
                    })
                    .finally(() => {
                      store.commit('setLoading', false)
                    });
                })
              }
            }
          }
        ]
      }
    },
    data() {
      return {
        reloadOrder: 0,
        BASE_URL: configs.BASE_URL,
        hrName: '',
        modalInfo: {
          show: true,
          title: '',
          body: ''
        },
        vms: [],
        vmSelected: '',
        hosting: {},
        plans: [],
        newPlan: {},
        actualPlan: {},
        actualProductPricing: null,
        planSelected: null,
        configGroups: [],
        configsSelected: [],
        paymentGateways: [],
        paymentMethodSelected: '',
        quote: {},
        unpaidInvoice: {},
        tableData: {
          data: []
        },
        apiMode: false,
        sortFunctions: FieldsDef.sortFunctions,
        onEachSide: 1,
        tableFields: FieldsDef.tableFields,
        dataModeFilterableFields: ['description'],
        itemsPerPage: [
          {
            value: 5
          },
          {
            value: 10
          }
        ]
      }
    },
    watch: {
      planSelected: function (val) {
        this.configsSelected = []
        this.configGroups = this.plans[val].product_config_group
        // Default values after selecting a plan
        for (var i = 0; i < this.configGroups.length; i++) {
          var configOptions = this.configGroups[i].product_config_option
          for (var j = 0; j < configOptions.length; j++) {
            var key = configOptions[j].id
            this.configsSelected[key] = configOptions[j].product_config_option_sub[0]
            // console.log(key)
          }
        }
      }
    },
    methods: {
      setup(){
        this.actualPlan = {}
        this.newPlan = {}

        this.reloadOrder = Math.random()
      },
      dateFormat(d, format) {
        return time.convert(d, format)
      },
      newPlanTable(item) {
        for (var prop in this.configsSelected) {
          if (Object.prototype.hasOwnProperty.call(this.configsSelected, prop)) {
            if (this.configsSelected[prop].id_label === item.id_label) {
              return this.configsSelected[prop].optionname
            }
          }
        }
        return item.value
      },
      clickPlan(key) {
        if (this.plans[key].upgrade_disabled === false) {
          this.planSelected = key
        }
      },
      stopLoadingAfter(counter) {
        if (counter >= 2) {
          store.commit('setLoading', false)
        }
      },
      isPlanSelected() {
        if (
          this.newPlan.product && this.newPlan.product.id &&
          this.newPlan.settings && this.newPlan.settings.every(setting => setting.hasOwnProperty('value'))) {
          return true
        } else {
          this.showToast(this.$t('upgrade.noPlanSelected'), {
            icon: 'fa-exclamation',
            position: 'top-center',
            duration: 3000,
            fullWidth: false
          })
          this.$refs.upgradeForm.currentStep = 1
          return false
        }
      },
      isPaymentSelected() {
        if (this.newPlan.paymentMethod && this.newPlan.paymentMethod.gateway) {
          return true
        } else {
          this.showToast(this.$t('upgrade.noPaymentSelected'), {
            icon: 'fa-exclamation',
            position: 'top-center',
            duration: 3000,
            fullWidth: false
          })
          return false
        }
      },
      getPlans() {
        if (typeof this.vmSelected.hosting_id !== 'undefined') {
          store.commit('setLoading', true)
          ajax.run(
            this,
            'customer/upgrades/' + this.vmSelected.hosting_id,
            data => {
              store.commit('setLoading', false)
              // If there is already an upgrade request created, Otherwise proceed
              if (data.success === false) {
                switch (data.code) {
                  case 100:
                    this.modalInfo.title = this.$t('upgrade.upgradeExistsTitle')
                    this.modalInfo.body = this.$t('upgrade.upgradeExistsBody')
                    this.$refs.modalInfo.open()
                    this.$refs.upgradeForm.currentStep = 0
                    break
                  case 110:
                    this.unpaidInvoice = data.data
                    this.$refs.existingInvoiceComponent.openModal()
                    this.$refs.upgradeForm.currentStep = 0
                    break
                }
              } else {
                this.plans = data.plans
                this.actualPlan = data.vps
                this.actualPlan.product_name = data.vps.product.name
                this.actualPlan.billingcycle = data.hosting.billingcycle
                this.actualPlan.product_priceoverride = data.vps.product.price.price

                this.actualPlan.pre_product_id = data.vps.product_id

                this.actualProductPricing = data.vps.priceoverride
                this.hosting = data.hosting
              }
            },
            error => {
              store.commit('setLoading', false)
              this.modalInfo.title = this.$t('upgrade.ErrorTitle')
              this.modalInfo.body = this.$t('upgrade.ErrorBody')
              this.$refs.modalInfo.open()
              this.$refs.upgradeForm.currentStep = 0
              console.log(error)
            }
          )
        }
      },
      upgradeQuote(createInvoice, successCallback) {
        store.commit('setLoading', true)
        ajax.run(
          this,
          'customer/upgrades/post/quote',
          data => {
            store.commit('setLoading', false)
            this.quote = data
            this.newPlan = {...this.newPlan, ...data}
            if (typeof successCallback !== 'undefined') {
              successCallback(this)
            }
            console.log('data', data)
            console.log('newPlan', this.newPlan)
            console.log('successCallback', successCallback)

          },
          error => {
            store.commit('setLoading', false)
            this.modalInfo.title = this.$t('upgrade.ErrorTitle')
            this.modalInfo.body = this.$t('upgrade.ErrorBody')
            this.$refs.modalInfo.open()
            this.$refs.upgradeForm.wizardCompleted = false
            this.$refs.upgradeForm.currentStep = 1
            console.log(error)
          },
          'post',
          {
            'hosting_id': this.vmSelected.hosting_id,
            'newPlan': this.newPlan,
            'plan_selected': this.newPlan.product.name,
            'payment_gateway': this.newPlan.paymentMethod.gateway,
            'create_invoice': createInvoice
          }
        )
      },
      setNewPlan(newPlan) {
        this.newPlan = {...this.newPlan, ...newPlan}
        if (this.newPlan.settings) {
          this.newPlan.settings = this.newPlan.settings.map(setting => {
            if (!setting.value) {
              setting.value = setting.min_value
            }
            return setting
          })
        }

        if (this.newPlan.product) {
          this.newPlan.product.billing_cycle = this.hosting.billingcycle
        }
      },
      formatPrice(objPrice) {
        let price = objPrice.price
        if (objPrice.region_id == 1) {
          price = objPrice.price.toLocaleString("pt-BR", {style: "currency", currency: "BRL"});
        } else {
          price = objPrice.price.toLocaleString("en-US", {style: "currency", currency: "USD"});
        }
        return price
      },
      formatProductPrice(prices) {
        let objPrice = {};
        if (prices.length > 0) {
          objPrice = prices.filter(price => price.datacenter_id == this.order.datacenter)[0]
        }

        return this.formatPrice(objPrice)
      },
      formatSetting(name, value, unity, type) {
        switch (name) {
          case 'nic_rate':
            return (value * 8) + ' Mbps'
          default:
            switch (type) {
              case 'toggle':
                return value ? this.$t('upgrade.true') : this.$t('upgrade.false')
              default:
                return value + ' ' + unity
            }
        }
      },
    }
  }
</script>


<style lang="scss">
  @import "../../sass/_variables.scss";
  @import "~bootstrap/scss/functions";
  @import "~bootstrap/scss/variables";
  @import "~bootstrap/scss/mixins/breakpoints";

  .widget.simple-vertical-wizard-widget {
    .widget-body {
      padding: 0 $widget-padding;
      @include media-breakpoint-down(sm) {
        padding: $widget-padding 0;
      }
    }
  }

  .wizard-body {
    padding: 2.25rem 10%;
  }

  .form-wizard-page {
    .form-group {
      min-width: 200px;
      max-width: 360px;
      width: 80%;
    }
  }

  .form-wizard-tab-content-text {
    width: 100%; // IE11 only
  }

  .position-box {
    margin-right: 0px;
    margin-top: 2px;
    cursor: pointer;
    background-color: $brand-primary;
    opacity: 0.6;

    &:last-child {
      margin-right: 0;
    }

    &:hover {
      opacity: 0.9;
    }

    &.selected {
      opacity: 1;
      border-style: solid;
    }
  }

  .total-yellow {
    background-color: #f7cc36 !important;
    color: white;
  }

  .total-green {
    background-color: #4ae387 !important;
    color: white;
  }

  .upgrade-disabled {
    cursor: default !important;
    background-color: $brand-danger !important;
    opacity: 0.6 !important;

    &:hover {
      opacity: 0.6;
    }
  }

  .fieldset-upgrade {
    width: 100%;
  }

  .fieldset-upgrade fieldset {
    margin-inline-start: 2px !important;
    margin-inline-end: 2px !important;
    padding-block-start: 0.35em !important;
    padding-inline-start: 0.75em !important;
    padding-inline-end: 0.75em !important;
    padding-block-end: 0.625em !important;
    min-inline-size: min-content !important;
    border-width: 2px !important;
    border-style: groove !important;
    border-color: threedface !important;
    border-image: initial !important;
  }

  .fieldset-upgrade legend {
    width: auto;
    font-weight: 600;
    font-size: 1rem;
  }

  .upgrade-input--container input {
  }

  .loading-box {
    height: 42px;
    position: relative;
    background-image: linear-gradient(to right, #EEE 0%, #FAFAFA 20%, #EEE 100%);
    background-color: #EEE;
    animation: 1s shimmer infinite linear;
  }

  .loading-box.label {
    width: 200px;
    height: 16px;
    margin-top: 50px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/upgrade/Upgrade.vue